
/*import React from 'react';
import DatePicker from 'react-datepicker';
import "../../Investment/datepicker.css";
const CustomInput = React.forwardRef(({ onClick, value, readOnly, ...rest }, ref) => {
    const handleClick = (e) => {
        e.stopPropagation();
        onClick(e);
    }
    return (
        <input
            onClick={handleClick}
            value={value}
            readOnly={true}
            {...rest}
            type="text"
            ref={ref}
        />
    );
});
const CustomDatePicker = ({ selectedDate, maxDate, minDate, onDateSelection }) => {

    const handleKeyDown = (e) => {
        if (!/^[0-9 -]$/.test(e.key) && e.key !== 'Backspace') {
            e.preventDefault();
        }
    };

    return (
        <div className="mui-datepicker">
            <i class="datepicker-icon far fa-calendar-alt"></i>
            <DatePicker
                selected={selectedDate}
                onKeyDown={handleKeyDown}
                onChange={onDateSelection}
                minDate={minDate}
                maxDate={maxDate}
                showYearDropdown
                // dateFormatCalendar="MMMM"
                yearDropdownItemNumber={100}
                placeholderText="dd-MM-yyyy"
                dateFormat="dd-MM-yyyy"
                peekNextMonth
                showMonthDropdown
                scrollableMonthDropdown
                showIcon
                showYearDropdown
                scrollableYearDropdown
                customInput={<CustomInput />}
            />
        </div>
    );
};

export default CustomDatePicker;
*/


import React from 'react';
import DatePicker from 'react-datepicker';
import "../../Investment/datepicker.css";

const CustomInput = React.forwardRef(
    ({ onClick, value = "", onChange, ...rest }, ref) => {

        const handleChange = (e) => {
            let inputValue = e.target.value;

            // remove non-numeric
            inputValue = inputValue.replace(/[^0-9]/g, '');

            // auto insert dash
            if (inputValue.length >= 3) {
                inputValue = `${inputValue.slice(0, 2)}-${inputValue.slice(2)}`;
            }
            if (inputValue.length >= 6) {
                inputValue = `${inputValue.slice(0, 5)}-${inputValue.slice(5)}`;
            }

            // limit to dd-MM-yyyy
            if (inputValue.length > 10) {
                inputValue = inputValue.slice(0, 10);
            }

            onChange({ target: { value: inputValue } });
        };

        const handleKeyDown = (e) => {
            if (!/^[0-9 -]$/.test(e.key) && e.key !== 'Backspace') {
                e.preventDefault();
            }
        };

        return (
            <input
                ref={ref}
                type="text"
                value={value}
                onClick={onClick}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                {...rest}
            />
        );
    }
);

const CustomDatePicker = ({
    selectedDate,
    maxDate,
    minDate,
    onDateSelection
}) => {

    return (
        <div className="mui-datepicker">
            <i className="datepicker-icon far fa-calendar-alt"></i>

            <DatePicker
                selected={selectedDate}
                onChange={(date) => onDateSelection(date)}
                minDate={minDate}
                maxDate={maxDate}
                showYearDropdown
                yearDropdownItemNumber={100}
                placeholderText="dd-MM-yyyy"
                dateFormat="dd-MM-yyyy"
                peekNextMonth
                showMonthDropdown
                scrollableMonthDropdown
                scrollableYearDropdown
                customInput={<CustomInput />}
            />
        </div>
    );
};

export default CustomDatePicker;
